<template>
	<div v-if="showBlockingSpinner" class="blocking-spinner">
		<div class="spinner">
  			<b-spinner label="Spinning" variant="light"></b-spinner>
  		</div>
	</div>
</template>

<script>
export default {
	components: {
	},
	methods: {
	},
	computed: {
		showBlockingSpinner() {
			return this.$store.state.showBlockingSpinner;
		}
	},
};
</script>
